import { render, staticRenderFns } from "./basic_plan.vue?vue&type=template&id=1a8765e6&scoped=true"
import script from "./basic_plan.vue?vue&type=script&lang=js"
export * from "./basic_plan.vue?vue&type=script&lang=js"
import style0 from "./basic_plan.vue?vue&type=style&index=0&id=1a8765e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8765e6",
  null
  
)

export default component.exports